import { initializeApp } from 'firebase/app'
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  getFirestore,
} from 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyAtSCjSr0-gnuwKD-1X2mWL6a21MX7lbfo",
  authDomain: "gtaa-soccer-penalty.firebaseapp.com",
  projectId: "gtaa-soccer-penalty",
  storageBucket: "gtaa-soccer-penalty.firebasestorage.app",
  messagingSenderId: "737005170795",
  appId: "1:737005170795:web:3698ef455342a0a713012e"
};

const app = initializeApp(firebaseConfig)

initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
})

const db = getFirestore(app)

export { db }
